import type { FC } from 'react'

import { NextLink } from 'components/NextLink'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const _BrandNameLink: FC<{ brandName: string; className?: string }> = ({
  brandName,
  className,
}) => {
  const brand = encodeURIComponent(brandName)
  const href = `/hakutulokset?brand=${brand}&queryString=${brand}`
  const { t } = useTranslation()

  return (
    <NextLink data-test-id="product-brand-link" href={href} className={className}>
      {t('All {{brandName}}-products', {
        /** Using the hyphen together with multiple words requires a leading space in Finnish */
        brandName: /\s/.test(brandName) ? `${brandName} ` : brandName,
      })}
    </NextLink>
  )
}

export const BrandNameLink = styled(_BrandNameLink)(
  ({ theme }) => theme.variants.body1.regular,
  ({ theme }) => ({
    color: theme.color.darkGrey700,

    '&:hover': {
      color: theme.color.darkGrey800,
      textDecoration: 'underline',
    },
  }),
)
